/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Event_Metrics_LabelInputs */

const en_summary_event_metrics_label = /** @type {(inputs: Summary_Event_Metrics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Metrics`)
};

const fr_summary_event_metrics_label = /** @type {(inputs: Summary_Event_Metrics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metriques d'evenement`)
};

const de_summary_event_metrics_label = /** @type {(inputs: Summary_Event_Metrics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignismetriken`)
};

const it_summary_event_metrics_label = /** @type {(inputs: Summary_Event_Metrics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metriche degli eventi`)
};

const ru_summary_event_metrics_label = /** @type {(inputs: Summary_Event_Metrics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метрики событий`)
};

const es_summary_event_metrics_label = /** @type {(inputs: Summary_Event_Metrics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métricas de eventos`)
};

const zh_cn2_summary_event_metrics_label = /** @type {(inputs: Summary_Event_Metrics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件指标`)
};

const ja_summary_event_metrics_label = /** @type {(inputs: Summary_Event_Metrics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントメトリクス`)
};

const hi_summary_event_metrics_label = /** @type {(inputs: Summary_Event_Metrics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट मेट्रिक्स`)
};

const pt_pt2_summary_event_metrics_label = /** @type {(inputs: Summary_Event_Metrics_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métricas de Eventos`)
};

/**
* | output |
* | --- |
* | "Event Metrics" |
*
* @param {Summary_Event_Metrics_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_event_metrics_label = /** @type {((inputs?: Summary_Event_Metrics_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Event_Metrics_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_summary_event_metrics_label(inputs)
	if (locale === "de") return de_summary_event_metrics_label(inputs)
	if (locale === "it") return it_summary_event_metrics_label(inputs)
	if (locale === "ru") return ru_summary_event_metrics_label(inputs)
	if (locale === "es") return es_summary_event_metrics_label(inputs)
	if (locale === "zh-CN") return zh_cn2_summary_event_metrics_label(inputs)
	if (locale === "ja") return ja_summary_event_metrics_label(inputs)
	if (locale === "hi") return hi_summary_event_metrics_label(inputs)
	if (locale === "pt-PT") return pt_pt2_summary_event_metrics_label(inputs)
	return en_summary_event_metrics_label(inputs)
});